import {
  ROUTE_MENU,
  ROUTE_REWARDS_REDEEM,
  VIEW_MORE_RECENT_ORDER,
} from "../constants";

/** Sticky footer banner on orders history, menu, and rewards pages (mobile design v2). */
export function isStickyFooterBannerRoute(pathname: string): boolean {
  if (pathname === VIEW_MORE_RECENT_ORDER) {
    return true;
  }

  if (pathname === ROUTE_REWARDS_REDEEM) {
    return true;
  }

  if (pathname === ROUTE_MENU) {
    return true;
  }

  if (!pathname.startsWith(`${ROUTE_MENU}/`)) {
    return false;
  }

  const categorySegment = pathname.slice(`${ROUTE_MENU}/`.length);
  if (!categorySegment || categorySegment.includes("/")) {
    return false;
  }

  return categorySegment !== "menuDetails";
}
